// Дзеркало Prisma enum GenerationMode. Режим генерації (D15, ТЗ §25).
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const GenerationMode = {
    FULL: 'FULL',
    FACULTY: 'FACULTY',
    DEPARTMENT: 'DEPARTMENT',
    COURSE: 'COURSE',
    GROUPS: 'GROUPS',
    SUBJECT: 'SUBJECT',
    OPTIMIZE: 'OPTIMIZE',
};
/** Значення в порядку оголошення в схемі. */
export const GENERATION_MODE_VALUES = ['FULL', 'FACULTY', 'DEPARTMENT', 'COURSE', 'GROUPS', 'SUBJECT', 'OPTIMIZE'];
export const GENERATION_MODE_LABELS = {
    FULL: 'Повна генерація',
    FACULTY: 'Генерація факультету',
    DEPARTMENT: 'Генерація кафедри',
    COURSE: 'Генерація курсу',
    GROUPS: 'Генерація груп',
    SUBJECT: 'Пошук часу для дисципліни',
    OPTIMIZE: 'Оптимізація поточного розкладу',
};
//# sourceMappingURL=generation-mode.js.map